export const SIDEBAR_STATE_LIST = {
    STORYBOARD: {
        TERM: 'clip_organizer.sidebar.storyboard',
        TYPE: 0,
    },
    EDIT: {
        TERM: 'my_video.tools.edit',
        TYPE: 1,
    },
    CHAT: {
        TERM: 'sidebar.profile.chat',
        TYPE: 2,
    },
};